import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    MatButtonModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatStepperModule,
    MatDividerModule,
    MatListModule,
    MatExpansionModule,
    MatCardModule,
    MatRadioModule,
    MatCheckboxModule,
    MatToolbar, 
    MatToolbarModule, 
    MatTabsModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatDialogModule,
     
} from '@angular/material';

import {MatTooltipModule} from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AgGridModule } from 'ag-grid-angular';
import { SharedDirectivesModule } from 'app/shared/directives/directives';

import { CotizadorService } from './services/cotizador.service';
import { CotizadorComponent } from './components/cotizador/cotizador.component';
import { CotizadorRoutingModule } from './cotizador-routing.module';
import { PlanComponent } from './components/plan/plan.component';
import { ProspectoComponent } from './components/prospecto/prospecto.component';
import { GeneralesProspectoComponent } from './components/generales-prospecto/generales-prospecto.component';
import { ProteccionComponent } from './components/proteccion/proteccion.component';
import { CotizacionComponent, DialogOverviewExampleDialog } from './components/cotizacion/cotizacion.component';
import { FormaPagoComponent } from './components/forma-pago/forma-pago.component';
import { FuseSidebarModule } from '@fuse/components';
import { FormsModule } from '@angular/forms';
import { BlockUIModule } from 'ng-block-ui';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    entryComponents: [ DialogOverviewExampleDialog],
   declarations: [DialogOverviewExampleDialog, CotizadorComponent, PlanComponent, ProspectoComponent, GeneralesProspectoComponent, ProteccionComponent, CotizacionComponent, FormaPagoComponent],
    imports: [
        CommonModule,
        CotizadorRoutingModule,
        SharedDirectivesModule,
        FormsModule,
        HttpClientModule,

        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatStepperModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatDividerModule,
        MatToolbarModule,
        MatListModule,
        MatExpansionModule,
        MatCardModule,
        MatRadioModule,
        MatCheckboxModule,
        FuseSidebarModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatDialogModule,
        MatTooltipModule,
        AgGridModule.withComponents([]),
        
        BlockUIModule.forRoot(),
        FuseSharedModule,
    ],
    exports: [GeneralesProspectoComponent],
    providers: [CotizadorService]
})
export class CotizadorModule {}
